export const INITIAL_STATE = {
    mapOptions: {
        clickableIcons: false,
        zoom: 12,
        mapTypeControl: false,
        zoomControl: false,
        streetViewControl: false,
        backgroundColor: "#eaeff3",
        styles: [
            { elementType: "geometry", stylers: [{ color: "#eaeff3" }] },
            {
                featureType: "road",
                elementType: "geometry",
                stylers: [{ color: "#ffffff" }]
            },
            {
                featureType: "road",
                elementType: "geometry.stroke",
                stylers: [{ color: "#ffffff" }]
            }
        ]
    }
};
